<script lang="ts">
  import AppBar from "../../../components/app-bar.svelte";
  import AppBarAction from "../../../components/app-bar-action.svelte";
  import PlaceProfile from "../../../components/places/profile.svelte";
  import { getTimeZone, getNow } from "../../../data/clock";
  import { displayOnMap } from "../../../domain/map";
  import { mapPath } from "../../../support/links";

  export let time = getNow();
  export let timeZone = getTimeZone();
  export let data;

  $: place = data.place;
  $: placeTypes = data.placeTypes;
  $: children = data.children;
  $: parent = data.parent;
  $: placeHoursGroup = data.placeHoursGroup;
  $: map = data.map;
  $: places = data.places;
  $: isOnMap = displayOnMap(map, places, place.id, $time);
</script>

<AppBar title={place.title}>
  {#if isOnMap}
    <AppBarAction
      icon="icon-locate"
      label="Map"
      context="See place on map"
      href={mapPath({ place: place.id })}
    />
  {/if}
</AppBar>

<PlaceProfile
  {place}
  {places}
  {placeTypes}
  {children}
  {parent}
  {placeHoursGroup}
  {time}
  {timeZone}
/>
